import { createRoot } from 'react-dom/client';
import UploadPrescription from '../pages/UploadPrescription';

const init = () => {
    createRoot(document.getElementById('quotation')).render(<UploadPrescription />);
};

export default init;
